<template>
<div>
  <homeNav/>
  <imgView/>
  <newsCont/>
  <backtop/>
  <homeFooter/>
</div>
</template>

<script>
import homeNav from '../../components/homeNav';
import imgView from "@/components/imgView";
import newsCont from './components/newsCont';
import homeFooter from '../../components/homeFooter';
import backtop from '../../components/backtop';
export default {
  name: "newsContent",
  components:{
    homeNav,
    imgView,
    newsCont,
    homeFooter,
    backtop,
  },
}
</script>

<style scoped>

</style>